import React from 'react';

import { IIconRotatableProps } from 'assets/icons/IconProps';

export const IconAI = ({ width = 22, height = 22, rotate, margin }: IIconRotatableProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 22 22"
    fill="none"
    style={{
      animation: `spin ${rotate}s linear infinite`,
      transformOrigin: 'center center',
      margin: margin,
    }}
  >
    <path
      d="M8.80087 5.60273C9.09593 4.85459 10.1547 4.85459 10.4498 5.60273L11.2848 7.71976C11.8252 9.09022 12.91 10.1751 14.2805 10.7155L16.3976 11.5505C17.1457 11.8456 17.1457 12.9043 16.3976 13.1994L14.2805 14.0344C12.91 14.5749 11.8252 15.6597 11.2848 17.0302L10.4498 19.1472C10.1547 19.8953 9.09593 19.8953 8.80087 19.1472L7.96592 17.0302C7.42542 15.6597 6.34059 14.5749 4.97013 14.0344L2.8531 13.1994C2.10496 12.9043 2.10496 11.8456 2.8531 11.5505L4.97013 10.7155C6.34059 10.1751 7.42542 9.09022 7.96592 7.71976L8.80087 5.60273Z"
      stroke="url(#paint0_linear_1963_23564)"
      strokeWidth="2.13"
    />
    <path
      d="M16.6488 2.50204C16.7595 2.22149 17.1566 2.22149 17.2672 2.50204L17.5802 3.29592C17.783 3.80984 18.1898 4.21666 18.7037 4.41934L19.4976 4.73245C19.7781 4.8431 19.7781 5.24015 19.4976 5.3508L18.7037 5.6639C18.1898 5.86659 17.783 6.2734 17.5802 6.78732L17.2672 7.58121C17.1566 7.86176 16.7595 7.86176 16.6488 7.58121L16.3358 6.78732C16.133 6.2734 15.7262 5.86659 15.2123 5.6639L14.4184 5.3508C14.1379 5.24015 14.1379 4.8431 14.4184 4.73245L15.2123 4.41934C15.7262 4.21666 16.133 3.80984 16.3358 3.29592L16.6488 2.50204Z"
      stroke="url(#paint1_linear_1963_23564)"
      strokeWidth="1.13"
    />
    <defs>
      <linearGradient
        id="paint0_linear_1963_23564"
        x1="9.62532"
        y1="5.04163"
        x2="9.62532"
        y2="19.7083"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#A80092" />
        <stop offset="1" stopColor="#4078C0" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_1963_23564"
        x1="16.958"
        y1="2.29163"
        x2="16.958"
        y2="7.79162"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#A80092" />
        <stop offset="1" stopColor="#4078C0" />
      </linearGradient>
    </defs>
  </svg>
);
